import * as React from 'react';
import { compile, defaultConfig } from 'squirrelly';

interface useFormCopyProps {
    copy?: string | null;
    data: Record<string, any>;
}

function decodeHtml(html: string) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}

export const useFormCopy = ({ copy, data }: useFormCopyProps) => {
    if (!copy) return '';
    const compiled = compile(copy);
    const string = compiled(data, defaultConfig);

    return decodeHtml(string);
};

export default useFormCopy;
